import React, { useEffect, useState } from 'react';
import { Drawer, message } from 'antd';
import { useWorkflowApi } from '../../api/workflow/workflow';
import { TWorkflowProject } from '../../models/workflow/workflow';
import ProjectCmntAndNote from '../../components/cards/ProjectCmntAndNoteCard';

export interface NotesHistoryProps {
    projectId: number;
    open: boolean;
    onClose: () => void;
}

const NotesHistory: React.FC<NotesHistoryProps> = ({
    projectId,
    open,
    onClose,
}) => {
    const {
        getWorkflowProjectsByProjectId,
    } = useWorkflowApi();
    const [history, setHistory] = useState<TWorkflowProject[]>([]);

    useEffect(() => {
        if (open) {
            getWorkflowProjectsByProjectId(projectId)
                .then(res => setHistory(Array.isArray(res.data) ? res.data : []))
                .catch(() => message.error("Impossible de charger l'historique des détails"));
        }
        // eslint-disable-next-line 
    }, [projectId, open]);

    return (
        <Drawer
            title="Historique des notes"
            placement="right"
            width={600}
            onClose={onClose}
            open={open}
        >
            {history.map(ht => (
                ht.details && (
                    <ProjectCmntAndNote
                        isEditable={false}
                        workflowProject={ht}
                        key={ht.id}
                    />
                )
            ))}
        </Drawer>
    );
};

export default NotesHistory;
